export const OCC_ENDPOINTS = {
  betonTypes: '/beton-commerce/api/v1/beton-types',
  betonOrderCalc: '/beton-commerce/api/v1/beton-orders:calculate',
  betonOrderConfirm: '/beton-commerce/api/v1/beton-orders',
};
